import { ArrowUpOnSquareIcon, TrashIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../context/auth-context';
import Tooltip from '../../components/Tooltip';
import { useState } from 'react';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}

export default function PurchaseOrder({
    setError,
    error,
    setPurchaseOrderNumber,
    setPurchaseOrderNotes,
    file,
    setFile,
    dragging,
    handleFileChange,
    fileTypeError,
    setFileTypeError,
}) {
    const { currentUser } = useAuth();
    const isAirCert = currentUser.Account.Name === 'AIR-CERT, LLC';

    const [showTooltip, setShowTooltip] = useState(false);

    const handleFileRemove = (e) => {
        const files = [...file];
        files.splice(e.target.id, 1);
        setFile(files);
    };

    let error2 = false;

    // create a drag and drop area

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setFileTypeError(null);
    };

    return (
        <div className='px-4 py-5 border-t border-gray-400 md:w-5/6 md:border-2 sm:p-6'>
            {!isAirCert && (
                <>
                    <div className='mt-4'>
                        <h3 className='text-xl font-medium leading-6 text-gray-900'>Upload Purchase Order</h3>
                        <div className='mt-2'>
                            <p className='text-sm text-gray-500'>Please select the file you wish to upload.</p>
                        </div>
                    </div>
                    <div className='mt-6'>
                        <button
                            onChange={handleFileChange}
                            onDragOver={handleDrag}
                            onClick={() => {
                                document.getElementById('file-upload').click();
                                setFileTypeError(null);
                            }}
                            type='button'
                            className={classNames(
                                dragging ? 'bg-white border-blue-primary' : '',
                                'block relative p-8 w-full text-center rounded-lg border-2 border-gray-300 border-dashed hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-primary focus:ring-offset-2',
                                fileTypeError ? 'border-red-600' : ''
                            )}
                        >
                            <ArrowUpOnSquareIcon className='mx-auto w-10 h-10 text-gray-400' />
                            <span className='sr-only'>upload a PDF or Word Document </span>
                            <span className='block mt-2 text-sm font-medium text-gray-500'>
                                Upload a PDF or Word Document{' '}
                            </span>
                            {file && !error && (
                                <span className='block mt-2 -mb-2 font-medium text-gray-500 underline text-md'>
                                    {file.length} file(s) selected
                                </span>
                            )}
                        </button>
                    </div>
                    {fileTypeError && (
                        <p className='pl-2 mt-2 text-sm text-red-600' id='email-error'>
                            {fileTypeError}
                        </p>
                    )}
                    <input
                        id='file-upload'
                        type='file'
                        multiple
                        className='hidden'
                        accept='.pdf, .docx'
                        onChange={(e) => {
                            handleFileChange(e);
                        }}
                    />
                    {file.map((file) => (
                        <div className='flex justify-between items-center space-y-4'>
                            <p key={file.name} className='block mt-2 -mb-2 text-sm font-medium text-gray-500'>
                                {file.name}
                            </p>
                            <TrashIcon
                                id={file.name}
                                onClick={handleFileRemove}
                                className='w-5 h-5 text-gray-500 cursor-pointer'
                            />
                        </div>
                    ))}
                </>
            )}
            <div>
                <label
                    htmlFor='poNumber'
                    className={classNames(
                        error ? 'text-red-600' : 'text-gray-700',
                        `block text-sm font-medium text-gray-700 p-1 -mb-0.5 ${!isAirCert ? 'mt-4' : ''}`
                    )}
                >
                    Purchase Order Number {!isAirCert && <span className='text-gray-400'>(required)</span>}
                </label>
                <div
                    onMouseEnter={() => {
                        setShowTooltip(true);
                    }}
                    onMouseLeave={() => {
                        setShowTooltip(false);
                    }}
                >
                    <input
                        onChange={(e) => {
                            setPurchaseOrderNumber(e.target.value);
                            setError(false);
                        }}
                        type='text'
                        name='poNumber'
                        id='poNumber'
                        disabled={dragging || isAirCert}
                        autoComplete='poNumber'
                        className={classNames(
                            error
                                ? 'placeholder-red-600 border-red-600 focus:ring-red-600'
                                : 'placeholder-gray-700 border-gray-400',
                            'block w-full shadow-sm sm:text-sm rounded-md disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-200',
                            dragging > 0 ? 'bg-gray-200' : ''
                        )}
                        placeholder={!isAirCert ? 'Enter Text' : ''}
                    />
                </div>
                {isAirCert && showTooltip && (
                    <Tooltip text='A Purchase Order Number will automatically be generated when the order is submitted' />
                )}
                {error && (
                    <p className='pl-2 mt-2 text-sm text-red-600' id='email-error'>
                        {error}
                    </p>
                )}

                <label
                    htmlFor='poNotes'
                    className={classNames(
                        error2 ? 'text-red-600' : 'text-gray-700',
                        'block text-sm font-medium text-gray-700 p-1 -mb-0.5 mt-4'
                    )}
                >
                    Purchase Order Notes
                </label>
                <textarea
                    onChange={(e) => {
                        setPurchaseOrderNotes(e.target.value);
                        setError(false);
                    }}
                    type='text'
                    name='poNotes'
                    disabled={dragging}
                    rows={2}
                    id='poNotes'
                    autoComplete='poNotes'
                    className={classNames(
                        error2
                            ? 'placeholder-red-600 border-red-600 focus:ring-red-600'
                            : 'placeholder-gray-700 border-gray-400',
                        'block p-3 w-full rounded-md border border-gray-400 shadow-sm sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-200'
                    )}
                    placeholder=''
                />
            </div>
        </div>
    );
}
